import React, { useCallback, useEffect, useState } from 'react';
import { X } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
}
const PURCHASES: Purchase[] = [{
  name: 'María G.',
  city: 'Miami, FL'
}, {
  name: 'Ana R.',
  city: 'Houston, TX'
}, {
  name: 'Carmen L.',
  city: 'Los Angeles, CA'
}, {
  name: 'Sofía M.',
  city: 'Chicago, IL'
}, {
  name: 'Laura P.',
  city: 'Phoenix, AZ'
}, {
  name: 'Patricia V.',
  city: 'San Antonio, TX'
}, {
  name: 'Gabriela S.',
  city: 'New York, NY'
}, {
  name: 'Rosa D.',
  city: 'Dallas, TX'
}, {
  name: 'Elena F.',
  city: 'Orlando, FL'
}, {
  name: 'Isabel T.',
  city: 'Denver, CO'
}, {
  name: 'Lucía H.',
  city: 'Tampa, FL'
}, {
  name: 'Valentina R.',
  city: 'Atlanta, GA'
}, {
  name: 'Andrea M.',
  city: 'Las Vegas, NV'
}, {
  name: 'Diana C.',
  city: 'Austin, TX'
}, {
  name: 'Claudia B.',
  city: 'Charlotte, NC'
}];
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [animClass, setAnimClass] = useState('');
  const [purchaseIndex, setPurchaseIndex] = useState(0);
  const showNotification = useCallback(() => {
    const purchase = PURCHASES[purchaseIndex % PURCHASES.length];
    setCurrentPurchase(purchase);
    setAnimClass('popup-enter');
    setIsVisible(true);
    // Auto-hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setAnimClass('popup-exit');
      setTimeout(() => {
        setIsVisible(false);
        setCurrentPurchase(null);
      }, 400);
    }, 5000);
    setPurchaseIndex(prev => prev + 1);
    return hideTimer;
  }, [purchaseIndex]);
  useEffect(() => {
    // Wait for page to fully load, then start after 8 seconds
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (purchaseIndex === 0) return;
    const interval = setTimeout(() => {
      showNotification();
    }, 20000);
    return () => clearTimeout(interval);
  }, [purchaseIndex]);
  const handleClose = () => {
    setAnimClass('popup-exit');
    setTimeout(() => {
      setIsVisible(false);
      setCurrentPurchase(null);
    }, 400);
  };
  if (!isVisible || !currentPurchase) return null;
  return <div className={`fixed bottom-20 md:bottom-6 left-3 md:left-5 z-[60] max-w-[280px] ${animClass}`} data-id="element-189">
      <div className="bg-white rounded-xl shadow-lg border border-border p-3 flex items-center gap-3 relative" data-id="element-190">
        <button onClick={handleClose} className="absolute -top-2 -right-2 w-5 h-5 bg-white border border-border rounded-full flex items-center justify-center shadow-sm hover:bg-gray-50 transition-colors" aria-label="Cerrar notificación" data-id="element-191">
          <X className="w-3 h-3 text-text-secondary" data-id="element-192" />
        </button>

        <img src="https://cdn.magicpatterns.com/uploads/h78tCJ2b46bbpyXU1hyyLc/portada.png" alt="Guía" className="w-11 h-11 rounded-lg object-cover flex-shrink-0 shadow-sm" data-id="element-193" />

        <div className="min-w-0" data-id="element-194">
          <p className="text-sm font-semibold text-text-primary truncate" data-id="element-195">
            {currentPurchase.name}
          </p>
          <p className="text-xs text-text-secondary truncate" data-id="element-196">
            {currentPurchase.city}
          </p>
          <p className="text-xs text-coral font-semibold mt-0.5" data-id="element-197">
            🛒 Compró por $6.36
          </p>
        </div>
      </div>
    </div>;
}